import {UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {OrderEntry} from '../../interfaces/order';



export const buildItems = (items?) => {
    if (!items) {
        return new UntypedFormArray([
            buildItem()
        ], Validators.required);
    } else {
        const entryItems = [];
        items.forEach(element => {
            entryItems.push(buildItem(element));
        });
        return new UntypedFormArray(entryItems, Validators.required);
    }
};


export const buildItem = (item?: OrderEntry) => {
    let newFormGroup: UntypedFormGroup;

    if (item) {
        newFormGroup = new UntypedFormGroup({
            id: new UntypedFormControl(item.id),
            budget: new UntypedFormControl(item.budget, Validators.required),
            material: new UntypedFormControl(item.material, Validators.required),
            description: new UntypedFormControl(item.description, Validators.required),
            quantity: new UntypedFormControl(item.quantity, Validators.required),
            costEach: new UntypedFormControl(item.costEach, Validators.required),
            discount: new UntypedFormControl(item.discount),
            unit: new UntypedFormControl(item.unit, Validators.required),
            code: new UntypedFormControl(item.code),
            ddt: new UntypedFormControl(item.ddt),
            invoices: new UntypedFormControl(item.invoices)
        });
    } else {
        newFormGroup = new UntypedFormGroup({
            id: new UntypedFormControl(guid()),
            budget: new UntypedFormControl(null, Validators.required),
            material: new UntypedFormControl(null, Validators.required),
            description: new UntypedFormControl('', Validators.required),
            quantity: new UntypedFormControl(0, Validators.required),
            costEach: new UntypedFormControl(0, Validators.required),
            discount: new UntypedFormControl(0),
            unit: new UntypedFormControl('pcs', Validators.required),
            code: new UntypedFormControl(),
            ddt: new UntypedFormControl(null),
            invoices: new UntypedFormControl(null)
        });
    }
    return newFormGroup;
};

export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};


export const calculateOrderMaterialItemValue = (costEach: number, quantity: number, discount: number) => {
    if (costEach === undefined || costEach === null) costEach = 0;
    if (quantity === undefined || quantity === null) quantity = 0;
    if (discount === undefined || discount === null) discount = 0;
    return (costEach * quantity) * (1 - discount / 100);
};